import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { defaultAxiosInstance } from "services/client"
import { ResponseData } from "services/common"

// const defaultURL = `${process.env.REACT_APP_BASE_API_URL || ""}/rbo/video`
const defaultURL = `${
  process.env.REACT_APP_BASE_API_URL || ""
}/rbo/video-with-stream`

// ---------- upload video api for Add a Video to Your Listing [step 5] ---------- //
export interface VideoUploadResponseData extends ResponseData {
  data: {
    uploaded: boolean
    message: string
  }
}

export interface VideoUploadResponse extends AxiosResponse {
  data: VideoUploadResponseData
}

export interface VideoUploadRequestData {
  propertyId: string
  width?: number
  height?: number
}
export interface VideoUploadRequest extends Partial<AxiosRequestConfig> {
  data: File
  params: VideoUploadRequestData
  onUploadProgress?: (progressEvent: ProgressEvent) => void // Add progress event handler
}

export function videoUpload(
  {
    data,
    params,
    method = "post",
    url = defaultURL,
    onUploadProgress,
    ...config
  }: VideoUploadRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<VideoUploadResponse> {
  return axiosInstance({
    method,
    url: `${url}?property-id=${params?.propertyId}&width=${
      params?.width || ""
    }&height=${params?.height || ""}&fileName=${data.name}`,
    data,
    headers: {
      "Content-Type": "application/octet-stream",
    },
    timeout: 0,
    onUploadProgress,
    ...config,
  }) as Promise<VideoUploadResponse>
}
